const statusDTO = {
  INPROGRESS: "In Progress",
  COMPLETED: "Completed",
  SIMULATED: "Simulated",
};

const DERDTO = {
  CGenset_Bat_PV: "C Genset + PV",
  Genset_Bat_PV: "Genset + PV",
  Bat_PV: "Bat + PV",
};

const componentDTO = {
  LOAD: "load",
  PV: "pv",
  Battery: "battery",
  Generator: "genset",
  ElectricalLoad: "load",
  Grid: "grid",
  grid: "grid",
  pv: "pv",
  battery: "battery",
  genset: "genset",
  load: "load",
  Genset: "genset",
  "Baseload Genset": "genset",
  "Multi Genset": "genset",
  "multi genset": "genset",
  "single genset": "genset",
  "Single Genset": "genset",
  "Baseload genset": "genset",
  electricalload: "load",
  ThermalLoad: "load",
  thermalload: "load",
  "baseload genset": "genset",
  Controller: "controller",
  controller: "controller",
  evcs: "evcs",
  EVCS: "evcs",
  EVCSLoad: "evcs",
  evcsload: "evcs",
};

export { statusDTO, DERDTO, componentDTO };
